import { render, staticRenderFns } from "./GBRightPaneMemberList.vue?vue&type=template&id=028a7d6a&scoped=true&"
import script from "./GBRightPaneMemberList.vue?vue&type=script&lang=js&"
export * from "./GBRightPaneMemberList.vue?vue&type=script&lang=js&"
import style0 from "./GBRightPaneMemberList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a7d6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTextField})
